"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var locale_manager_1 = __importDefault(require("@gin-betting/locale-manager"));
var types_1 = require("../types");
var constants_1 = require("../constants");
var getBettingOptions_1 = __importDefault(require("./getBettingOptions"));
// TODO: Rename into something more correct like getValidStreamUrl etc
function getStreamWithCurrentLocale(_a) {
    var _b;
    var allStreams = _a.allStreams, streamIds = _a.streamIds, isCompact = _a.isCompact;
    var streamUrl = constants_1.defaultStreamUrl;
    var streams = streamIds.reduce(function (acc, streamId) {
        var stream = allStreams.get(streamId);
        if (!stream) {
            return acc;
        }
        if (isCompact === undefined) {
            acc.push(stream);
            return acc;
        }
        var isDesktop = !isCompact;
        var platform = lodash_1.find(stream.platforms, function (currentPlatform) {
            return isDesktop
                ? currentPlatform.type === types_1.View.StreamType.DESKTOP
                : currentPlatform.type === types_1.View.StreamType.MOBILE;
        });
        if (platform && platform.enabled) {
            acc.push(stream);
        }
        return acc;
    }, []);
    var streamWithCurrentLocale = findStream(streams, getBettingOptions_1.default().locale);
    if (streamWithCurrentLocale) {
        return streamWithCurrentLocale.url;
    }
    if (streams.length > 0) {
        var defaultStream = findStream(streams);
        var lastStream = streams[streams.length - 1];
        streamUrl = ((_b = (defaultStream || lastStream)) === null || _b === void 0 ? void 0 : _b.url) || streamUrl;
    }
    return streamUrl;
}
exports.default = getStreamWithCurrentLocale;
function findStream(streams, cmsLocale) {
    if (cmsLocale === void 0) { cmsLocale = locale_manager_1.default.defaultConfig.cms[0]; }
    return locale_manager_1.default.getItemByDataFeed(streams, {
        from: 'cms',
        value: cmsLocale,
        predicate: function (s) { return s.locale; },
    });
}
//# sourceMappingURL=getStreamWithCurrentLocale.js.map